export const modalHR = {
    "greska": "Greška",
    "zatvori": "Zatvori"
};